import * as yup from 'yup'
import { useEffect } from 'react'
import { useFormik } from 'formik'
import { useApiCall } from '../../../component/custom-hooks/api-call'
import "react-datepicker/dist/react-datepicker.css";
import { FormArea, FeildWraper, FeildError, FormLabel, SelectSearch } from '../../../component/form/form-layout'

const AddMeterForm = ({ onClose = () => { }, onError = () => { }, onSuccess = () => {}, onSubmit = () => { }, currentData, Style, buildings = [] }) => {
    const apiCall = useApiCall();
    useEffect(() => {
        if (!currentData?.id) return;

        formik.setValues({
            name: currentData?.name || "",
            status: currentData?.status,
        });
    }, [currentData]);

    const validationSchema = yup.object().shape({
        meterNumber: yup.string().required('This Field is required'),
        location: yup.string().required('This Field is required'),
        accountNumber: yup.string().required('This Field is required'),
        
    });
    const formik = useFormik({
        initialValues: {
            meterNumber: "",
            accountNumber: "",
            location: "",
            remarks: ""
        },
        enableReinitialize: true,
        validationSchema,
        onSubmit: async (values) => {
            let extraData = {}
            if (currentData?.id) {
                extraData = {
                    "category_id": currentData?.id,
                }
            }
            const apiData = JSON.stringify({
                ...extraData,
                "location_id": values?.location,
                "meter_number": values?.meterNumber,
                "floor_account_number" : values?.accountNumber,
                "remarks": values?.remarks
            });

            try {
                const resp = await apiCall({ method: "post", url: currentData?.id ? `update-supply-category` : `electricity-bills/meter/add`, data: apiData });
                onSubmit();
                onSuccess(resp?.message || `Request Submitted`);
                formik.resetForm();
            } catch (error) {
                onError(error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong")
            }
        }
    });

    return (
        <>
            <form onSubmit={formik.handleSubmit} className={Style.modal_main}>
                <div className={Style.modal_body}>
                    <FormArea>
                        <FeildWraper width='100%'>
                            <FormLabel required>Location</FormLabel>

                            <SelectSearch
                                name="location"
                                placeholder="- Select Location -"
                                onChange={(val) => {formik.setFieldValue("location", val);}}
                                value={formik.values.location}
                                options={buildings?.map((eachBuilding) => ({label: eachBuilding?.name, value: eachBuilding?.id}))}
                                // options={[
                                //     {label: "Active", value: 1},
                                //     {label: "In Active", value: 0},
                                // ]}
                            />
                            {formik.touched.location && formik.errors.location && (
                                <FeildError>{formik.errors.location}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper width='100%'>
                            <FormLabel required>Meter Number</FormLabel>
                            <input
                                type={'text'}
                                name={'meterNumber'}
                                onChange={formik.handleChange}
                                value={formik.values.meterNumber}
                                placeholder='Meter Number'
                            />
                            {formik.touched.meterNumber && formik.errors.meterNumber && (
                                <FeildError>{formik.errors.meterNumber}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper width='100%'>
                            <FormLabel required>Account Number</FormLabel>
                            <input
                                type={'text'}
                                name={'accountNumber'}
                                onChange={formik.handleChange}
                                value={formik.values.accountNumber}
                                placeholder='Account Number'
                            />
                            {formik.touched.accountNumber && formik.errors.accountNumber && (
                                <FeildError>{formik.errors.accountNumber}</FeildError>
                            )}
                        </FeildWraper>
                        <FeildWraper width='100%'>
                            <FormLabel>Remarks / Notes</FormLabel>
                            <input
                                type={'text'}
                                name={'remarks'}
                                onChange={formik.handleChange}
                                value={formik.values.remarks}
                                placeholder='Remarks / Notes'
                            />
                            {formik.touched.remarks && formik.errors.remarks && (
                                <FeildError>{formik.errors.remarks}</FeildError>
                            )}
                        </FeildWraper>

                        

                    </FormArea>
                </div>

                <div className={Style.modal_foot}>
                    <button type='reset' className={`${Style.dcmb__cancel}`} onClick={onClose}>Discard</button>
                    <button type='submit' className={`${Style.dcmb__submit}`}>Apply</button>
                </div>
            </form>
        </>
    )
}

export default AddMeterForm
